export class EntNotificationsFilter {
  page: number = 1;
  size: number = 15;
  isRead: boolean = false
}